import { chEpisodeOfCareFragment } from "@/modules/patients/services/ch/chEpisodeOfCareFragment"
import { deEpisodeOfCareFragment } from "@/modules/patients/services/de/deEpisodeOfCareFragment"
import { Country } from "@/types/__generated__/union-types"

export const getEpisodeOfCareFragment = (country: Country) => {
  switch (country) {
    case "CH":
      return chEpisodeOfCareFragment
    case "DE":
      return deEpisodeOfCareFragment
  }
}
